<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container " v-for="(question,idx) in this.template.arrange"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div class="q-content">{{question['content']}}</div>
            <div>
                <div class=" d-flex flex-column gap-2">
                    <p class="my-0">Answers</p>
<!--                    <div class="d-flex justify-content-between gap-3 my-3">-->
<!--                        <div class="answers-style">-->
<!--                            <div class="d-flex flex-column gap-3 answers-container">-->
<!--                                <div v-for="(a,index) in question['answers']"-->
<!--                                     class="d-flex gap-4 align-items-center ans-content"-->
<!--                                     draggable="true"-->
<!--                                     @dragenter="dragEnterHandler($event, a, idx, index)"-->
<!--                                     @dragstart="dragStartHandler($event, a, idx, index)"-->
<!--                                     @drop="dropHandler($event, a, idx, index)"-->
<!--                                     @dragenter.prevent-->
<!--                                     @dragover.prevent-->
<!--                                     @dragend="dragExitHandler($event, a, idx, index)">-->
<!--                             <span class="sort-icon"-->
<!--                             >-->
<!--                                 <font-awesome-icon :icon="['fas', 'bars']" size="sm"/>-->
<!--                             </span>-->
<!--                                    <div class="m-c-answer-container position-relative"-->
<!--                                         :style="{backgroundColor: a.bgColor}">-->
<!--                                        <textarea-->

<!--                                                class="q-input w-100"-->
<!--                                                autocomplete="off"-->
<!--                                                @input="answerTextChangeHandler($event, idx, index ,'arrange')"-->
<!--                                                :placeholder="a.key" v-model="a.value">-->
<!--                                        </textarea>-->
<!--                                        &lt;!&ndash;                                        <span class="delete-answer-icon"&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                              @click="deleteAnswerHandler($event, idx, index, 'arrange')">&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                        <font-awesome-icon :icon="['fas', 'times']" size="sm"/>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                    </span>&ndash;&gt;-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <draggable class="list-group w-100" :list="question['answers']" group="people" @change="dragExitHandler($event, idx)">
                        <template #item="{ element, index }">
                            <div class="d-flex justify-content-between gap-3 my-3 dragableStyle">
                                <div class="answers-style">
                                    <div class="d-flex gap-3 answers-container" >
                                        <span class="sort-icon">
                                            <font-awesome-icon :icon="['fas', 'bars']" size="sm"/>
                                        </span>

                                        <div class="m-c-answer-container position-relative" :style="{backgroundColor: element.bgColor}">
                                            <textarea
                                                    class="q-input w-100"
                                                    autocomplete="off"
                                                    :placeholder="element.key" v-model="element.value">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import draggable from "vuedraggable";
    export default {
        name: 'arrange-component',
        data() {
            return {
                originalData: {},
                sourceData: {},
                destData: {}
            }
        },
        async mounted() {
        },
        components:{
            draggable
        },
        props: ['template', 'userAnswers'],
        methods: {
            changeHandler(e, qidx, aidx) {
                console.log(this.template.freeText[qidx].answers[aidx])
                this.userAnswers.answers.forEach((answer, index) => {

                    if (answer['question_id'] === this.template.freeText[qidx]['answers'][aidx]['question_id']) {
                        this.userAnswers.answers.splice(index, 1);
                    }

                });
                this.userAnswers.answers.push({...this.template.freeText[qidx]['answers'][aidx]});
                console.log(this.userAnswers.answers)
                this.template.changeFlag = true;
            },
            async dragStartHandler(e, data, qIdx, aIdx) {
                console.log({data}, {qIdx}, {aIdx});

                this.originalData = this.template['arrange'][qIdx]['answers'].map((obj) => ({...obj}));
                this.sourceData = {
                    idx: aIdx,
                    order: data.order,
                    value: data.value
                }
            },
            dropHandler(e, data, qIdx, aIdx) {
                console.log("dropHandler => ", {data}, {qIdx}, {aIdx});
                this.template['arrange'][qIdx]['answers'][aIdx]['bgColor'] = "transparent";
                this.originalData = this.template['arrange'][qIdx]['answers'].map((obj) => ({...obj}));
            },
            dragEnterHandler(e, data, qIdx, aIdx) {
                e.preventDefault();
                const index = this.sourceData.idx;
                let sourceValue = null;
                let sourceId = null;

                let destId = null;
                let destValue = null;

                this.destData.idx = aIdx;
                this.template['arrange'][qIdx]['answers'] = this.originalData.map((obj) => ({...obj}));

                if (index !== +aIdx) {
                    sourceId = this.template['arrange'][qIdx]['answers'][index]['id'];
                    sourceValue = this.template['arrange'][qIdx]['answers'][index]['value'];

                    destId = this.template['arrange'][qIdx]['answers'][aIdx]['id'];
                    destValue = this.template['arrange'][qIdx]['answers'][aIdx]['value'];

                    this.template['arrange'][qIdx]['answers'][aIdx]['id'] = sourceId;
                    this.template['arrange'][qIdx]['answers'][aIdx]['value'] = sourceValue;
                    this.template['arrange'][qIdx]['answers'][index]['id'] = destId;
                    this.template['arrange'][qIdx]['answers'][index]['value'] = destValue;
                    this.template['arrange'][qIdx]['answers'][aIdx]['bgColor'] = "#034560";
                }
                console.log("dragEnterHandler => ", {data}, {qIdx}, {aIdx}, {sourceValue}, {destValue});
            },
            dragExitHandler(e, qIdx) {
                console.log("dragExitHandler ", this.template['arrange'][qIdx]['answers']);
                console.log("this.userAnswers ", this.userAnswers);

                this.template['arrange'][qIdx]['answers'].forEach((arrAns, idx) => {
                    arrAns.order = idx + 1;
                    this.userAnswers.answers.forEach((ans, index) => {
                        if (+ans.id === +arrAns.id) {
                            this.userAnswers.answers.splice(index, 1);
                        }
                    })
                })

                let uData =  this.template['arrange'][qIdx]['answers'].map((obj) => ({...obj}));
                uData.forEach((answer) => {
                    answer.value = answer.order;
                });

                this.userAnswers.answers.push(...uData);
                console.log("uAns =>> ", this.userAnswers.answers)
                this.template.changeFlag = true;
            },
        }
    }
</script>

<style scoped>
    .q-input {
        pointer-events: none;
        display: flex;
        flex-wrap: wrap;
        background-color: transparent !important;
        border: none;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: auto;
        height: 45px;
        max-height: 60px;
    }

    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }

    .sort-icon {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .answers-style {
        padding: 11px;
        overflow: auto;
        max-height: 270px;
    }

    .m-c-answer-container {
        width: 470px;
        border: 1px solid #39525C;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        color: var(--main-color);
        gap: 4px;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: var(--main-color);
        background-color: transparent;
        outline: 0;
        pointer-events: none;
    }

    .delete-answer-icon {
        position: absolute;
        top: -5px;
        right: -4px;
        display: flex;
        background-color: #E95626;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #032a3a;
        cursor: pointer;
    }

    .dragableStyle{
        width:50%
    }

</style>